<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Chat Room</h1>
    </div>
    <div class="d-flex flex-column justify-content-between">
      <div style="height: 43rem" class="overflow-auto mb-3" id="chat_list">
        <div v-for="(chat, index) in arr_chat" :key="index" class="mb-3">
          <div v-if="chat.type == 'sender'" class="card">
            <div class="card-body d-flex justify-content-between">
              <div>
                {{ chat.created_at.format('HH:mm') }}
              </div>
              <div>
                {{ chat.message }}
              </div>
            </div>
          </div>
          <div v-else class="card">
            <div class="card-body d-flex justify-content-between">
              <div>
                {{ chat.message }}
              </div>
              <div>
                {{ chat.created_at.format('HH:mm') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="form-group col-2 text-center">
            <button class="btn btn-primary">send</button>
          </div>
          <div class="form-group col-8">
            <input type="text" class="form-control" v-model="message"/>
          </div>
          <div class="form-group col-2 text-center">
            <button class="btn btn-primary" @click="save()">send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'

import 'summernote/dist/summernote.css'
import summernote from 'summernote'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      message: '',
      arr_chat: [],
      chat: {},
      self_profile: {},
      socket: null,
    }
  },
  sockets:{
    'App\\Events\\ChatEvent'(data) {
      data[1].chat_room.created_at = moment(data[1].chat_room.created_at)
      data[1].chat_room.type = data[1].chat_room.sender.name == this.self_profile.name ? 'sender' : 'receiver'
      this.arr_chat.push(data[1].chat_room)

      var context = this
      setTimeout(() => {
        context.scroll_to_bottom()
      }, 100)
    }
  },
  async mounted(){
    await this.get_profile_data()
    await this.get_data()
    await this.get_chat_room_data()
    this.scroll_to_bottom()

    this.$socket.emit('subscribe', {
      channel: 'chat.' + this.$route.query.id,
    })
  },
  methods:{
    async get_data(){
      try{
        var response = await axios.get(base_url+'/chat?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.chat = response_data.data
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async get_chat_room_data(){
      try{
        var response = await axios.get(base_url+'/chat-room?chat_id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_chat = response_data.data.data
          this.arr_chat.forEach((data) => {
            data.created_at = moment(data.created_at)
          })
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async get_profile_data(){
      try{
        var response = await axios.get(base_url+'/auth/profile')

        var response_data = response.data
        if(response_data.status == "success"){
          this.self_profile = response_data.data
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    scroll_to_bottom(){
      const el = document.getElementById('chat_list')
      el.scrollTop = el.scrollHeight
    },
    async save(){
      try{
        if(this.chat.receiver_id == '')
          this.$toasted.show('Receiver is empty')
        else if(this.chat.id == '')
          this.$toasted.show('Chat is empty')
        else if(this.message == '')
          return
        else{
          var data = {}
          data.receiver = {
            id: this.chat.receiver_id
          }
          data.chat_id = this.chat.id
          data.message = this.message

          this.message = ''
          var response = await axios.post(base_url+'/chat-room',data)

          var response_data = response.data
          if(response_data.status == "success"){

          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    }
  }
}
</script>
